function normalizeDate(input) {
  if (!input) {
    return null;
  }
  const date = input instanceof Date ? input : new Date(input);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Format a value to YYYY-MM-DD.
 * @param {Date | string | number} value - Date-like input.
 * @returns {string} Formatted date string or empty string.
 */
export function formatDate(value) {
  const date = normalizeDate(value);
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Format a value to YYYY-MM-DD HH:MM:SS.
 * @param {Date | string | number} value - Date-time input.
 * @returns {string} Formatted date-time string or empty string.
 */
export function formatDateTime(value) {
  const date = normalizeDate(value);
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
